import * as DialogPrimitive from '@rn-primitives/dialog';
import * as React from 'react';
import { cn } from '../../lib/utils';

// Copied from https://rnr-docs.vercel.app/components/dialog/
export const DialogOverlay = React.forwardRef<
  DialogPrimitive.OverlayRef,
  DialogPrimitive.OverlayProps
>(({ className, ...props }, ref) => {
  const { open } = DialogPrimitive.useRootContext();
  return (
    <DialogPrimitive.Overlay
      className={cn(
        'bg-black/80 flex justify-center items-center p-2 absolute top-0 right-0 bottom-0 left-0',
        open
          ? 'web:animate-in web:fade-in-0'
          : 'web:animate-out web:fade-out-0',
        className,
      )}
      {...props}
      ref={ref}
    />
  );
});
